import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GenrePicker } from "@/components/GenrePicker";
import { SOCIAL_PLATFORMS } from "@/config/socialPlatforms";

export const ProfileEditModal = ({ editForm, setEditForm, saving, saveProfile, onCancel }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="bg-card border border-border rounded-3xl p-5 space-y-3 shadow-lg"
      data-testid="edit-profile-form"
    >
      <h3 className="font-heading font-bold text-sm text-card-foreground">Modifier mon profil</h3>
      <Input
        placeholder="Pseudo"
        value={editForm.pseudo}
        onChange={(e) => setEditForm({ ...editForm, pseudo: e.target.value })}
        className="bg-white border-border rounded-xl text-card-foreground placeholder:text-muted-foreground h-10 text-sm"
        data-testid="edit-pseudo-input"
      />
      <textarea
        placeholder="Bio (parle-nous de toi...)"
        value={editForm.bio}
        onChange={(e) => setEditForm({ ...editForm, bio: e.target.value })}
        className="w-full bg-white border border-border rounded-xl px-3 py-2 text-sm text-card-foreground placeholder:text-muted-foreground focus:border-[#FF6B35] outline-none resize-none h-20"
        data-testid="edit-bio-input"
      />
      <Input
        placeholder="Ville"
        value={editForm.city}
        onChange={(e) => setEditForm({ ...editForm, city: e.target.value })}
        className="bg-white border-border rounded-xl text-card-foreground placeholder:text-muted-foreground h-10 text-sm"
        data-testid="edit-city-input"
      />
      <div className="space-y-2">
        <p className="text-xs text-muted-foreground font-medium">Reseaux sociaux</p>
        {SOCIAL_PLATFORMS.map(({ key, icon: Icon, placeholder }) => (
          <div key={key} className="flex items-center gap-2">
            <Icon className="w-4 h-4 text-muted-foreground shrink-0" />
            <Input
              placeholder={placeholder}
              value={editForm.social_links?.[key] || ""}
              onChange={(e) => setEditForm({
                ...editForm,
                social_links: { ...editForm.social_links, [key]: e.target.value },
              })}
              className="bg-white border-border rounded-xl text-card-foreground placeholder:text-muted-foreground h-9 text-xs"
              data-testid={`edit-social-${key}`}
            />
          </div>
        ))}
      </div>
      <div>
        <p className="text-xs text-muted-foreground mb-2">Genres</p>
        <GenrePicker
          selected={editForm.genres || []}
          onChange={(genres) => setEditForm({ ...editForm, genres })}
        />
      </div>
      <div className="flex gap-2">
        <button
          onClick={saveProfile}
          disabled={saving}
          className="flex items-center gap-1 bg-[#FF6B35] text-white font-bold px-5 py-2.5 rounded-full text-xs hover:scale-105 active:scale-95 transition-transform disabled:opacity-50"
          data-testid="save-profile-btn"
        >
          <Check className="w-3 h-3" />
          {saving ? "..." : "Enregistrer"}
        </button>
        <button
          onClick={onCancel}
          className="flex items-center gap-1 bg-muted text-muted-foreground px-5 py-2.5 rounded-full text-xs border border-border"
          data-testid="cancel-edit-btn"
        >
          <X className="w-3 h-3" /> Annuler
        </button>
      </div>
    </motion.div>
  );
};
